import React, { Component } from 'react'
import styles from '../common.module.less'
import './index.module.less'
import Cookie from '../../lib/Cookie'
import conversion from '../../lib/conversion'
export default class Footer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      trans: !Cookie('stt')
    }
  }
  componentDidMount () {
    if (!this.state.trans) {
      conversion.trans(this.state.trans)
    }
  }
  handleTrans (e) {
    e.preventDefault()
    this.setState(prevState => ({
      trans: !prevState.trans
    }))
    conversion.trans(!this.state.trans)
    if (this.state.trans) {
      Cookie('stt', 1, 10, { 'domain': 'youku.com' })
    } else {
      Cookie('stt', '', -1, { 'domain': 'youku.com' })
    }
  }
  handleDownload (e) {
    e.preventDefault()
    let isMac = window.navigator && navigator.platform && navigator.platform.indexOf('Mac') === 0
    let src = isMac ? '//iku.youku.com/channelinstall/macyweb' : '//iku.youku.com/channelinstall/ywebbottom'
    window.ikuDownloadIng = true
    var iframe = document.createElement('iframe')
    iframe.width = 0
    iframe.height = 0
    iframe.src = src
    document.body.appendChild(iframe)
    window.setTimeout(function () {
      document.body.removeChild(iframe)
      window.ikuDownloadIng = false
    }, 2000)
  }
  render () {
    return (
      <div className={styles.container}>
        <div className='g-footer'>
          <dl className='g-w1'>
            <dt>
              <a target='_blank' href='//c.youku.com/aboutcn/youtu' data-aplus-clk='38f3847b'>关于大优酷事业群</a>
            </dt>
            <dd>
              <a target='_blank' href='//c.youku.com/link' data-aplus-clk='7d558573'>友情链接</a>
            </dd>
            <dd>
              <a target='_blank' href='//c.youku.com/aboutcn/adservice/' data-aplus-clk='12cf413e'>广告服务</a>
            </dd>
            <dd>
              <a target='_blank' href='//c.youku.com/aboutcn/contact' data-aplus-clk='50567790'>联系我们</a>
            </dd>
          </dl>
          <dl className='g-w2'>
            <dt>
                优酷热门
            </dt>
            <dd>
              <a target='_blank' href='//tv.youku.com/' data-aplus-clk='2de3d3d6'>剧集</a>
              <a target='_blank' href='//movie.youku.com/' data-aplus-clk='1d3c1533'>电影</a>
              <a target='_blank' href='//zy.youku.com/' data-aplus-clk='42c3ed17'>综艺</a>
              <a target='_blank' href='//music.youku.com/' data-aplus-clk='403f8573'>音乐</a>
              <a target='_blank' href='//child.youku.com/' data-aplus-clk='16e241cd'>少儿</a>
              <a target='_blank' href='//news.youku.com/' data-aplus-clk='6becaa3d'>资讯</a>
              <a target='_blank' href='//jilupian.youku.com/' data-aplus-clk='6c13fee4'>纪实</a>
              <a target='_blank' href='//gongyi.youku.com/' data-aplus-clk='505abbc'>公益</a>
            </dd>
            <dd>
              <a target='_blank' href='//sports.youku.com/' data-aplus-clk='1fb0cd64'>体育</a>
              <a target='_blank' href='//auto.youku.com/' data-aplus-clk='4a8cd812'>汽车</a>
              <a target='_blank' href='//tech.youku.com/' data-aplus-clk='2a76b7e6'>科技</a>
              <a target='_blank' href='//finance.youku.com/' data-aplus-clk='1703e4ab'>财经</a>
              <a target='_blank' href='//ent.youku.com/' data-aplus-clk='6243b4d4'>娱乐</a>
              <a target='_blank' href='//culture.youku.com/' data-aplus-clk='d82b8d2'>文化</a>
              <a target='_blank' href='//comic.youku.com/' data-aplus-clk='413d1a11'>动漫</a>
              <a target='_blank' href='//fun.youku.com/' data-aplus-clk='2752b93'>搞笑</a>
            </dd>
            <dd>
              <a target='_blank' href='//travel.youku.com/' data-aplus-clk='5c5ee115'>旅游</a>
              <a target='_blank' href='//fashion.youku.com/' data-aplus-clk='60e3f1b7'>时尚</a>
              <a target='_blank' href='//baby.youku.com/' data-aplus-clk='5db95cab'>亲子</a>
              <a target='_blank' href='//edu.youku.com/' data-aplus-clk='247380b7'>教育</a>
              <a target='_blank' href='//game.youku.com/' data-aplus-clk='648fd64b'>游戏</a>
              <a target='_blank' href='//vip.youku.com/' data-aplus-clk='4689a679'>会员</a>
              <a target='_blank' href='//faxian.youku.com/?from=PC_main_nav' data-aplus-clk='7517c3dd'>发现</a>
              <a target='_blank' href='//list.youku.com/category/video' data-aplus-clk='504daece'>片库</a>
            </dd>
          </dl>
          <dl className='g-w3'>
            <dt>产品中心</dt>
            <dd>
              <a href='javascript:void(0);' onClick={this.handleDownload.bind(this)} data-aplus-clk='6a904296'>Mac客户端</a>
            </dd>
            <dd>
              <a target='_blank' href='//mobile.youku.com/index/wireless' data-aplus-clk='7f6a3eec'>手机客户端</a>
            </dd>
            <dd>
              <a target='_blank' href='//cloud.youku.com/' data-aplus-clk='937c04d'>视频云</a>
            </dd>
          </dl>
          <dl className='g-w4'>
            <dt>用户</dt>
            <dd>
              <a target='_blank' href='//mp.dayu.com/' data-aplus-clk='346af3ac'>开通大鱼号</a>
              <a target='_blank' href='//www.jingguan.ai' data-aplus-clk='1b5538cd'>鲸观</a>

            </dd>

            <dt>支持</dt>
            <dd>
              <a id='sttrans' onClick={this.handleTrans.bind(this)} data-aplus-clk='b317efa'>{this.state.trans ? '繁体字' : '简体字'}</a>
              <a target='_blank' href='//sky.vip.youku.com/bwsvip/136/c5597b1a?wh_ttid=pc' data-aplus-clk='4e1dd7d3'>在线反馈</a>
            </dd>
            <dd>
              <a target='_blank' href='//mapp.youku.com/service/banquan' data-aplus-clk='4b1584d8'>侵权投诉</a>
            </dd>
          </dl>
          <div className='g-hr' />
          <dl className='g-w1'>
            <dd><a target='_blank' href='//mapp.youku.com/service/licence/' data-aplus-clk='4b32d735'>网络文化经营许可证 京网文[2014]0934-236号</a></dd>
            <dd><a target='_blank' href='http://www.bj.cyberpolice.cn/index.htm' data-aplus-clk='e5d5cbb'>网络110报警服务</a></dd>
            <dd> 药品服务许可证(京)-经营-2015-0029</dd>
            <dd><a target='_blank' href='//mapp.youku.com/service/gbdsjmzzjyxkz' data-aplus-clk='292d960'>节目制作经营许可证京字670号</a></dd>
            <dd>违法不良信息举报: 电话4008100580、</dd>
            <dd>邮箱youkujubao@service.alibaba.com</dd>

          </dl>
          <dl className='g-w2'>
            <dd>请使用者仔细阅读优酷<a target='_blank' href='//mapp.youku.com/service/agreement' className='mr0' data-aplus-clk='6d9902bb'>《用户协议》</a>、<a target='_blank' href='//mapp.youku.com/service/flsm2' className='mr0' data-aplus-clk='60e14c7a'>《隐私政策》</a>、</dd>
            <dd><a target='_blank' href='//mapp.youku.com/service/banquan' className='mr0' data-aplus-clk='3124df17'>《版权声明》</a>、<a target='_blank' href='//mapp.youku.com/service/piracy' className='mr0' data-aplus-clk='16b5a1f7'>《反盗链声明》</a>、<a target='_blank' href='//mapp.youku.com/service/zhanghuzhuxiao' className='mr0' data-aplus-clk='164e2c87'>《账号注销协议》</a>和</dd>
            <dd><a target='_blank' href='//mapp.youku.com/service/agreementALL' className='mr0' data-aplus-clk='5a39cb80'>历史协议文本</a></dd>
            <dd>Copyright©2018 优酷 youku.com 版权所有</dd>
            <dd><a target='_blank' href='//mapp.youku.com/service/0108283' data-aplus-clk='4c85a51f'>信息网络传播视听节目许可证0108283号</a></dd>
          </dl>
          <dl className='g-w3'>
            <dd><a target='_blank' href='http://www.miibeian.gov.cn/' data-aplus-clk='278f8bac'>京ICP证060288号</a></dd>
            <dd><a target='_blank' href='http://mapp.youku.com/service/chubanwu' data-aplus-clk='63516fe3'>网络出版服务许可证</a></dd>
            <dd><a target='_blank' href='http://www.bjjubao.org/' data-aplus-clk='6f94a028'>北京互联网举报中心</a></dd>
            <dd><a target='_blank' href='http://www.bjwhzf.gov.cn/bjwhzfhd/accuse.do' data-aplus-clk='53ccecbd'>北京12318文化市场举报热线</a></dd>
            <dd><a target='_blank' href='http://mapp.youku.com/service/yingyezhizhao' data-aplus-clk='f029a45'>营业执照</a> <a target='_blank' href='http://mapp.youku.com/service/chuban' data-aplus-clk='716c0d38'>出版物经营许可证</a></dd>
          </dl>
          <dl className='g-w4'>
            <a className='qcode' target='_blank' href='//mobile.youku.com/index/wireless' data-aplus-clk='8c5fd5'><img src='//r1.ykimg.com/0510000058D0FEA1ADC0AE058F099020' width='84px' /></a>
          </dl>
          <div className='g-authentication'>
            <a className='aut-1' target='_blank' href='http://www.hd315.gov.cn/beian/view.asp?bianhao=010202006082400023' data-aplus-clk='7936fc44'>经营性网站<br />>备案信息</a>
            <a className='aut-2' target='_blank' href='http://www.itrust.org.cn/yz/pjwx.asp?wm=1786197705' data-aplus-clk='6c1c0045'>中国互联网<br />诚信联盟</a>
            <a className='aut-3' target='_blank' href='http://www.12377.cn/' data-aplus-clk='6afa2556'>中国互联网<br />举报中心</a>
            <a className='aut-4' target='_blank' href='http://www.12377.cn/node_548446.htm' data-aplus-clk='42e7597d'>网络举报<br />APP下载</a>
            <a className='aut-5' target='_blank' href='http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000017' data-aplus-clk='33afce81'>京公网安备<br />11000002000017</a>
            <a className='aut-6' target='_blank' href='http://sq.ccm.gov.cn/ccnt/sczr/service/business/emark/toDetail/0D76560AE65141FF9FEFE3481D205C50' data-aplus-clk='4465b1b3'>网络文化<br />经营单位</a>
            <a className='aut-7' target='_blank' href='http://www.12377.cn/' data-aplus-clk='ad3ec52'>暴恐音视频<br />举报专区</a>
          </div>
        </div>
      </div>
    )
  }
}
